<template>
  <div>
    <img class="d-flex justify-center seedling-img" src="seedling.png" />

    <div class="welcome d-flex justify-center">{{ welcomeMessage }}</div>
    <v-form ref="form">
      <div v-if="showForm" class="d-flex justify-center">
        <v-sheet class="input-form">
          <v-row class="d-flex justify-center">
            <div class="login-word">Password Setup</div>
          </v-row>
          <v-row>
            <div class="label">Password</div>
          </v-row>
          <v-row>
            <v-text-field
              v-model="password"
              class="ma-4 input-field invalidClass"
              background-color="#f2eae2"
              filled
              single-line
              dense
              outlined
              color="#35606f"
              :append-icon="showPass ? 'visibility' : 'visibility_off'"
              id="js-password"
              :type="showPass ? 'text' : 'password'"
              @click:append="showPass = !showPass"
              :rules="passwordRules"
            ></v-text-field>
          </v-row>
          <v-row>
            <div class="label">Repeat Password</div>
          </v-row>
          <v-row>
            <v-text-field
              v-model="password2"
              class="ma-4 input-field invalidClass"
              background-color="#f2eae2"
              filled
              single-line
              dense
              outlined
              color="#35606f"
              :append-icon="showPass ? 'visibility' : 'visibility_off'"
              id="js-password-2"
              :type="showPass ? 'text' : 'password'"
              @click:append="showPass = !showPass"
              :error-messages="errorMessage"
              @keyup.enter="clicked"
              :rules="passwordRules"
            ></v-text-field>
          </v-row>
          <v-row class="d-flex justify-center">
            <v-btn
              id="js-login"
              class="login-btn default-action-btn"
              @click="clicked"
            >
              Submit
            </v-btn>
          </v-row>
        </v-sheet>
      </div>
    </v-form>
  </div>
</template>

<script>
import EventBus from "@/lib/eventBus"
import { UsersAPI } from "@/lib/api"
import { apiConfig } from "@/lib/config"
import User from "@/lib/user"
import validationMixin from "@/mixins/validationMixin"

export default {
  mixins: [validationMixin],
  data: function() {
    return {
      email: "",
      password: "",
      password2: "",
      showPass: false,
      errorMessage: "",
      welcomeMessage:
        "Welcome to the Independence Trust Program. Please enter a password twice that you would like to use for this site.",
      showForm: true
    }
  },
  mounted() {
    UsersAPI.checkValidPasswordResetToken(this.$route.params.token).then(
      response => {
        if (response.status != "OK") {
          this.welcomeMessage =
            "We're sorry. This link is no longer valid. Please get in touch with your contact at Lineage Family Office to begin the setup again."
          this.showForm = false
        }
      },
      error => {
        console.log(error)
      }
    )
  },
  methods: {
    clicked: function() {
      if (this.$refs.form.validate()) {
        UsersAPI.setPassword(
          this.$route.params.token,
          this.password,
          this.password2
        ).then(
          response => {
            this.$toasted.clear()
            this.$toasted.success(
              `Password has been set. Use this password to login`,
              {
                icon: "verified_user",
                position: "top-center",
                duration: 2200,
                fullWidth: false,
                theme: "bubble"
              }
            )
            this.$router.replace({ name: "login" })
          },
          error => {
            this.errorMessage = error.response.data
          }
        )
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../scss/variables";
@import "../scss/buttons";

$section-width: 300px;

.input-form {
  width: $section-width;
  margin-top: 25px;
  padding: 50px 30px 0px 30px;
  border-radius: 25px;
}

.label {
  color: $dark-blue;
  font-weight: 800;
  margin: 0px 0px -15px 20px;
}

.seedling-img {
  max-width: 200px;
  margin: 20px auto 0px auto;
}

.login-btn {
  width: 175px;
  margin-top: 10px;
  margin-bottom: 60px;
}

.welcome {
  margin: 0px auto;
  font-family: $main-font-family;
  font-weight: 700;
  color: $orange;
  font-size: 1.8em;
  padding-bottom: 20px;
  max-width: 400px;
}

.login-word {
  font-style: italic;
  color: $light-yellow;
  font-size: 1.8em;
  text-transform: uppercase;
  font-weight: 500;
  padding-bottom: 20px;
}
</style>
